import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FormInput from "./Shared/FormInput";
import FormAlert from "./Shared/FormAlert";
import LanguageToggle from "./Shared/LanguageToggle";
import cognitoAuthService from "../../services/cognitoAuthService";
import { LOGO_URL } from "../../constants";
import "../../styles/auth.css";

const ResetPassword = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const email = (searchParams.get("email") || "").replace(/ /g, "+");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(!email ? t("forgotPassword.pleaseEnterEmail") : "");
  const [success, setSuccess] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const handleSubmit = async () => {
    if (!code || !newPassword) {
      setError(t("forgotPassword.pleaseEnterCodeAndPassword"));
      return;
    }

    try {
      setLoading(true);
      setError("");
      await cognitoAuthService.confirmForgotPassword(email, code, newPassword);
      setSuccess(t("forgotPassword.passwordResetSuccess"));
    } catch (err) {
      setError(err.message || t("forgotPassword.passwordResetFailed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="brand-header">
        <img src={LOGO_URL} alt="Logo" className="brand-logo" />
      </div>
      <div className="login-card">
        <LanguageToggle />
        <div className="form-container">
          <h3>{t("forgotPassword.title")}</h3>
          <FormAlert type="error" message={error} />
          <FormAlert type="success" message={success} />

          {!success && email && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <p className="info-text">
                {t("forgotPassword.resetCodeInfo")}
              </p>
              <FormInput
                id="reset-code"
                value={code}
                type="text"
                label={t("forgotPassword.resetCodeLabel")}
                placeholder={t("forgotPassword.resetCodePlaceholder")}
                disabled={loading}
                onChange={setCode}
              />
              <FormInput
                id="new-password"
                value={newPassword}
                type="password"
                label={t("forgotPassword.newPasswordLabel")}
                placeholder={t("forgotPassword.newPasswordPlaceholder")}
                disabled={loading}
                onChange={setNewPassword}
              />
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? (
                  <span className="spinner"></span>
                ) : (
                  <span>{t("forgotPassword.resetPasswordButton")}</span>
                )}
              </button>
            </form>
          )}

          <div className="form-footer">
            <button
              type="button"
              onClick={() => navigate("/login")}
              className="link"
            >
              {t("forgotPassword.backToSignIn")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
